module.exports = function(app) {
    app.directive('passwordStrength', ['$document', function($document) {

        return {
            scope: {
                passwordStrength: '='
            },
            template: require('directives/passwordStrength.html'),
            link: function(scope,element) {

                scope.passwordRules = {
                    minLength: 8,
                    maxLength: 64
                };
                if(scope.$parent.$parent.passwordRules){
                    scope.passwordRules.minLength = scope.$parent.$parent.passwordRules.minLength;
                    scope.passwordRules.maxLength = scope.$parent.$parent.passwordRules.maxLength;
                }
                //Sets a watch on the inputted password field
                scope.$watch('passwordStrength',
                    function(){

                        //sets and initializes variables
                        var newPassword = scope.passwordStrength;
                        scope.passwordStrengthDisplay= '';
                        scope.passwordRules = {
                            oneNumber: false,
                            properLength: false,
                            specialChars: false,
                            upperCase: false,
                            lowerCase: false,
                            count: 0,
                            minLength: 8,
                            maxLength: 64
                        };

                        if(newPassword != undefined){
                            //Determination of password strength based on various conditions
                                if (newPassword.length > 0) {
                                        scope.passwordStrengthDisplay = 'Weak';
                                }

                                // Test length
                                if (newPassword.length >= scope.passwordRules.minLength) {
                                    scope.passwordRules.properLength = true;
                                }else {
                                    scope.passwordRules.properLength = false;
                                }

                                // Test for one number
                                if (/[0-9]/.test(newPassword)) {
                                    scope.passwordRules.oneNumber = true;
                                    scope.passwordRules.count++;
                                }
                                // Test for special chars
                                if (/[#!@$%^&*()\-_=+|;:'",<.>?`~\\\/\[\]]/.test(newPassword)) {
                                    scope.passwordRules.specialChars = true;
                                    scope.passwordRules.count++;
                                }
                                // Test for upper/lower
                                if (newPassword.toLowerCase() !== newPassword) {
                                    scope.passwordRules.upperCase = true;
                                    scope.passwordRules.count++;
                                }
                                if(newPassword.toUpperCase() !== newPassword){
                                    scope.passwordRules.lowerCase = true;
                                    scope.passwordRules.count++;
                                }

                                // Determine password strength
                                if (scope.passwordRules.properLength && scope.passwordRules.count > 2) {
                                    scope.passwordStrengthDisplay = 'Fair';
                                }
                                if (newPassword.length > scope.passwordRules.minLength + 1 && scope.passwordRules.specialChars && scope.passwordRules.count > 2) {
                                    scope.passwordStrengthDisplay = 'Good';
                                }
                                if (newPassword.length > scope.passwordRules.minLength + 2 && scope.passwordRules.count > 3) {
                                    scope.passwordStrengthDisplay = 'Excellent';
                                }

                        }
                    });
            }
        };
    }]);
};